import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { Button } from "components";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import PinCode from "hooks/PinCode/PinCode";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  ChangePassword,
  ChangePin,
  ChangeProfileNumber,
  ChangeProfileEmail
} from "service/AuthService";
import {
  changePassword,
  changePhoneNumber,
  changePinCode,
  postMail
} from "store/slices/UserSlice";
import userInfo from "utils/userInfo";
import styles from "../PersonalMenu.module.scss";
import {
  checkPinCode,
} from "service/AuthService";

const PersonalInfo = ({
  title,
  data,
  phone,
  setPhone,
  email,
  setEmail,
  setNotify,
  icons,
  newPassword,
  setNewPassword,
  newPin,
  setNewPin,
  button,
  btnId,
}) => {
  const { t } = useTranslation("common");
  const [pinCode, setPinCode] = useState();
  const [openModal, setOpenModal] = useState(false);

  const [file, setFile] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [emailUser, setEmailUser] = useState("");

  const [password, setPassword] = useState("");
  const [currentDynamicUser, getDynamic] = useState();
  const [EfficiencyColor, setEfficiencyColor] = useState("grey");
  const dispatch = useDispatch();
  const [backgroundImage, setBackgroundImg] = useState(null);
  const [pinOrComment, setPinOrComment] = useState(false);
  const user = userInfo();
  const navigate = useNavigate();
  const [userPinCode] = useState(user?.pin);

  const [successPin, setSuccessPin] = useState(false);

  const createUserPin = async () => {
    if (String(pinCode)?.length < 4 || !pinCode) {
      setNotify({
        isOpen: true,
        message: t('profile.pin.enter_pin'),
        type: "error",
        sound: "error",
      });
    } else if (String(pinCode).length === 4) {
      if (pinCode === user?.pin) {
        setOpenModal(false);
        setNotify({
          isOpen: true,
          message: t('profile.pin.set_new_pin'),
          type: "error",
          sound: "error",
        });
      } else {
        try {
          let response = await ChangePin(pinCode);
          dispatch(
            changePinCode({
              pin: pinCode,
            })
          );
          let userData = JSON.parse(localStorage.getItem('user'));

          userData.pin = pinCode;


          localStorage.setItem('user', JSON.stringify(userData));
          setNotify({
            isOpen: true,
            message: t('profile.pin.pin_changed'),
            type: "success",
            sound: "success",
          });

          setTimeout(() => {
            setOpenModal(true);
          }, 1000);


        } catch (error) {
          setNotify({
            isOpen: true,
            message: t('common.error'),
            type: "error",
            sound: "error",
          });
        }
      }
    }
  };

 const handleSubmit = async (event) => {
  event.preventDefault();

  if (!pinCode || String(pinCode).length < 4) {
    setNotify({
      isOpen: true,
      message: "Введите Пин!",
      type: "error",
      sound: "error",
    });
    return;
  }

  try {
    const pinCheckResponse = await checkPinCode(pinCode, user.userId);

    if (!pinCheckResponse.data.success) {
      setNotify({
        isOpen: true,
        message: t('profile.pin.wrong_pin'),
        type: "error",
        sound: "error",
      });
      return;
    }

    setNotify({
      isOpen: true,
      message: t('profile.pin.correct_pin'),
      type: "success",
      sound: "success",
    });

    setPinCode('');
    setPinOrComment(false);
    setSuccessPin(true);

    if (!password) {
      setNotify({
        isOpen: true,
        message: t('profile.password.no_new_password'),
        type: "error",
        sound: "error",
      });
      return;
    }

    await ChangePassword(password);
    dispatch(changePassword({ new_password: password }));

    setNotify({
      isOpen: true,
      message: t('profile.password.password_changed'),
      type: "success",
      sound: "success",
    });

    // Wave Final (P1-F14): после смены пароля backend инвалидирует токен;
    // безопасно — выкинуть на login (см. ProfilePage handleSubmit).
    setTimeout(() => {
      try {
        localStorage.removeItem('token');
        localStorage.removeItem('refresh');
      } catch {}
      window.location.assign('/');
    }, 500);

  } catch (error) {
    setNotify({
      isOpen: true,
      message: t('common.server_error_retry'),
      type: "error",
      sound: "error",
    });
  }
};


  const handleSubmit2 = async (event) => {
  event.preventDefault();

  if (!pinCode || String(pinCode).length < 4) {
    setNotify({
      isOpen: true,
      message: "Введите Пин!",
      type: "error",
      sound: "error",
    });
    return;
  }

  try {
    const pinCheckResponse = await checkPinCode(pinCode, user.userId);

    if (!pinCheckResponse.data.success) {
      setNotify({
        isOpen: true,
        message: t('profile.pin.wrong_pin'),
        type: "error",
        sound: "error",
      });
      return;
    }

    setNotify({
      isOpen: true,
      message: t('profile.pin.correct_pin'),
      type: "success",
      sound: "success",
    });

    setPinCode('');
    setPinOrComment(false);
    setSuccessPin(true);

    if (!phoneNumber) {
      setNotify({
        isOpen: true,
        message: t('profile.phone.no_new_phone'),
        type: "error",
        sound: "error",
      });
      return;
    }

    await ChangeProfileNumber(phoneNumber);
    dispatch(changePhoneNumber({ numberPhone: phoneNumber }));

    setNotify({
      isOpen: true,
      message: t('profile.phone.phone_changed'),
      type: "success",
      sound: "success",
    });

    // Wave Final (P1-F14): телефон обновлён в store через dispatch выше — без reload.

  } catch (error) {
    setNotify({
      isOpen: true,
      message: t('common.server_error_retry'),
      type: "error",
      sound: "error",
    });
  }
};
const handleSubmit3 = async (event) => {
  event.preventDefault();

  if (!pinCode || String(pinCode).length < 4) {
    setNotify({
      isOpen: true,
      message: "Введите Пин!",
      type: "error",
      sound: "error",
    });
    return;
  }

  try {
    const pinCheckResponse = await checkPinCode(pinCode, user.userId);

    if (!pinCheckResponse.data.success) {
      setNotify({
        isOpen: true,
        message: t('profile.pin.wrong_pin'),
        type: "error",
        sound: "error",
      });
      return;
    }

    setNotify({
      isOpen: true,
      message: t('profile.pin.correct_pin'),
      type: "success",
      sound: "success",
    });

    setPinCode('');
    setPinOrComment(false);
    setSuccessPin(true);

    if (!emailUser) {
      setNotify({
        isOpen: true,
        message: t('profile.email.no_new_email'),
        type: "error",
        sound: "error",
      });
      return;
    }

    let response = await ChangeProfileEmail(emailUser);
    dispatch(postMail({ email: emailUser }));

    if (response?.data?.message) {
      setNotify({
        isOpen: true,
        message: response.data.message,
        type: "error",
        sound: "error",
      });
      setOpenModal(true);
      setEmail(false);
    } else {
      setNotify({
        isOpen: true,
        message: t('profile.email.email_changed'),
        type: "success",
        sound: "success",
      });
      // Wave Final (P1-F14): email обновлён в store — без reload.
    }

  } catch (error) {
    setNotify({
      isOpen: true,
      message: t('common.server_error_retry'),
      type: "error",
      sound: "error",
    });
  }
};
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClickImg = () => {
    setIsExpanded(!isExpanded);
  };

  const pinLogIn = async () => {
  if (String(pinCode).length !== 4) {
    setNotify({
      isOpen: true,
      message: t('profile.pin.enter_4_digit_pin'),
      type: "warning",
      sound: "error",
    });
    return;
  }

  try {
    const response = await checkPinCode(pinCode, user.userId); 
    if (response.data.success) {
      setNotify({
        isOpen: true,
        message: t('profile.pin.correct_pin'),
        type: "success",
        sound: "success",
      });

      setPinOrComment(true);
      setPinCode(null);
    } else {
      setNotify({
        isOpen: true,
        message: t('profile.pin.wrong_pin'),
        type: "error",
        sound: "error",
      });
    }
  } catch (error) {
    setNotify({
      isOpen: true,
      message: t('common.server_error_retry'),
      type: "error",
      sound: "error",
    });
  }
};

  const handleClosePhone = () => {
    setOpenModal(true);
    setPhone(false);
  };
  const handleCloseEmail = () => {
    setOpenModal(true);
    setEmail(false);
  };

  const handleClosePin = () => {
    setOpenModal(true);
    setNewPin(false);
  };

  return (
    <>
      {phone && phone !== undefined ? (
        <div>
          {pinOrComment ? (
            <ModalWindow
              openModal={!openModal}
              setOpenModal={setOpenModal}
              modalText={t('profile.pin.enter_pin_label')}
              width={"unset"}
            >
              <>
                <PinCode setPinCode={setPinCode} passwordVisible={false} />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    onClick={handleClosePhone}
                    className={styles.btn_pin_close}
                  >
                    {" "}
                    {t('common.close')}
                  </Button>
                  <Button onClick={handleSubmit2} className={styles.btn_pin}>
                    {t('common.confirm')}
                  </Button>
                </div>
              </>
            </ModalWindow>
          ) : (
            <div className={styles.PersonalInfo}>
              <input
                type="number"
                maxLength={2}
                onChange={(e) => setPhoneNumber(e.target.value)}
                className={styles.password_change}
                placeholder={t('profile.phone.enter_phone')}
                style={{
                  WebkitAppearance: "none", 
                  appearance: "none", 
                }}
                onKeyDown={(e) => {
                  if (e.target.value.length >= 12 && e.key !== "Backspace") {
                    e.preventDefault();
                  }
                }}
              />
              <div>
                <button
                  className={styles.btn2}
                  style={{ border: "none" }}
                  onClick={() => setPhone(false)}
                >
                  <CloseIcon sx={{ fontSize: "20px" }} />
                </button>
                <Button
                  className={styles.btn2}
                  onClick={() => setPinOrComment(true)}
                >
                  <DoneIcon />
                </Button>
              </div>
            </div>
          )}
        </div>
      ) : newPassword ? (
        <div>
          {pinOrComment ? (
            <ModalWindow
              openModal={!openModal}
              setOpenModal={setOpenModal}
              modalText={t('profile.pin.enter_pin_label')}
              width={"unset"}
            >
              <>
                <PinCode setPinCode={setPinCode} passwordVisible={false} />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    onClick={() => setOpenModal(true)}
                    className={styles.btn_pin_close}
                  >
                    {" "}
                    {t('common.close')}
                  </Button>
                  <Button onClick={handleSubmit} className={styles.btn_pin}>
                    {t('common.confirm')}
                  </Button>
                </div>
              </>
            </ModalWindow>
          ) : (
            <div className={styles.PersonalInfo}>
              <input
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                className={styles.password_change}
                placeholder={t('profile.password.enter_new_password')}
              />
              <button
                className={styles.btn2}
                style={{ border: "none" }}
                onClick={() => setNewPassword(false)}
              >
                <CloseIcon sx={{ fontSize: "20px" }} />
              </button>
              <Button
                className={styles.btn2}
                onClick={() => setPinOrComment(true)}
              >
                <DoneIcon />
              </Button>
            </div>
          )}
        </div>
      ) : newPin ? (
        <div>
          {pinOrComment ? (
            <ModalWindow
              openModal={!openModal}
              setOpenModal={setOpenModal}
              modalText={t('profile.pin.enter_new_pin')}
            >
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <PinCode setPinCode={setPinCode} passwordVisible={false} />
                  <Button
                    onClick={handleClosePin}
                    className={styles.btn_pin_close}
                  >
                    {" "}
                    {t('common.close')}
                  </Button>
                  <Button onClick={createUserPin} className={styles.btn_pin}>
                    {t('common.confirm')}
                  </Button>
                </div>
              </>
            </ModalWindow>
          ) : (
            <ModalWindow
              openModal={!openModal}
              setOpenModal={setOpenModal}
              modalText={t('profile.pin.enter_old_pin_full')}
              width={"unset"}
            >
              <>
                <PinCode setPinCode={setPinCode} passwordVisible={false} />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    onClick={handleClosePin}
                    className={styles.btn_pin_close}
                  >
                    {" "}
                    {t('common.close')}
                  </Button>
                  <Button onClick={pinLogIn} className={styles.btn_pin}>
                    {t('common.confirm')}
                  </Button>
                </div>
              </>
            </ModalWindow>
          )}
        </div>
      ) : email && email !== undefined ? (
        <div>
          {pinOrComment ? (
            <ModalWindow
              openModal={!openModal}
              setOpenModal={setOpenModal}
              modalText={t('profile.pin.enter_pin_label')}
              width={"unset"}
            >
              <>
                <PinCode setPinCode={setPinCode} passwordVisible={false} />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    onClick={handleCloseEmail}
                    className={styles.btn_pin_close}
                  >
                    {" "}
                    {t('common.close')}
                  </Button>
                  <Button onClick={handleSubmit3} className={styles.btn_pin}>
                    {t('common.confirm')}
                  </Button>
                </div>
              </>
            </ModalWindow>
          ) : (
            <div className={styles.PersonalInfo}>
              <input
                type="email"
                onChange={(e) => setEmailUser(e.target.value)}
                className={styles.password_change}
                placeholder={t('profile.email.enter_new_email')}
                style={{
                  WebkitAppearance: "none", 
                  appearance: "none", 
                }}
                onKeyDown={(e) => {
                  if (e.target.value.length >= 50 && e.key !== "Backspace") {
                    e.preventDefault();
                  }
                }}
              />
              <div>
                <button
                  className={styles.btn2}
                  style={{ border: "none" }}
                  onClick={() => setEmail(false)}
                >
                  <CloseIcon sx={{ fontSize: "20px" }} />
                </button>
                <Button
                  className={styles.btn2}
                  onClick={() => setPinOrComment(true)}
                >
                  <DoneIcon />
                </Button>
              </div>
            </div>
          )}
        </div>
      ) : (

        <div className={styles.PersonalInfo}>
          <span style={{ display: "flex", alignItems: "center" }}>
            <span style={{ display: "flex", color: "gray" }}>{icons}</span>
            {title}
          </span>
          <span>
            {data}
            {button !== undefined ? (
              <button
                id={btnId ? styles.btnId : null}
                className={styles.btn_change}
                onClick={() => {
                  button(true);
                }}
              >
                {t('profile.change')}
              </button>
            ) : null}
          </span>
        </div>
      )}
    </>
  );
};

export default PersonalInfo;
